export enum IBusinessType {
  ONLINE = 'online',
  INSTORE = 'physical',
  BOTH = 'physical_online'
}

export enum IBusinessQuestionKey {
  ONLINE = 'operation.online',
  PHYSICAL = 'operation.physical',
  BOOKING = 'operation.booking'
}

export enum EBusinessStatus {
  hidden = 'Hidden',
  active = 'Active',
  inactive = 'Inactive',
  unknown = 'Unknown'
}

export enum EBusinessRewardsStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive'
}

export enum EBusinessReportType {
  OFFER = 'offer',
  COIN = 'coin',
  OFFER_COINS = 'offer-coins'
}

export interface IBusinessSignupOperationQuestion {
  id: string;
  question: string;
}

export interface IBusinessSignupOperationAnswer {
  id: string;
  value: boolean;
}

export interface IBusinessSignupOperationDTO {
  answers: IBusinessSignupOperationAnswer[];
}

export interface IBusinessCreateData {
  name: string;
  locationName: string;
  address: string;
  addressAdditional: string;
  type: string;
  city: string;
  state: string;
  zip: string;
  phone: string;
  phoneCountryCode: string;
  phoneCountryIso: string;
  website: string;
  stateName: string;
  fullAddress: string;
  merchantId: string;
  country: string;
  /** ISO 3166-1 alpha-2. The API resolves the country by this code, because
   * `country` carries the name translated by the `x-lang` header. */
  countryIso2?: string;
  categoryId: string;
  otherCategory: string;
  onlineMerchantSignup?: boolean;
  operationType?: IBusinessType;
  coinNetworkSignup?: boolean;
  businessLeadId?: string;
  signupFrom?: string;
}

export interface IBusinessResponseListDto {
  id: string;
  logo: { id: string; publicPath: any };
  name: string;
  address: string;
  city: string;
  state: string;
  zip: string;
  website: string;
  phone: string;
  type: IBusinessType;
}

export interface IBusinessGoogleLocationData {
  internationalPhoneNumber: string;
  websiteUri: string;
  formattedAddress: string;
  location: {
    address: string;
    fullAddress: string;
    postCode: string;
    cityName: string;
    stateName: string;
    stateCode: string;
    countryName: string;
    countryCode: string;
  };
  category: {
    id: string;
    name: string;
  };
  subcategories: string[];
  name: string;
  placeId?: string;
}
